import React, { useState, useEffect } from "react"
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    FormGroup,
    NavItem,
    NavLink,
    Row,
    Label,
    Input,
    TabContent,
    TabPane
} from "reactstrap"
import { TwitterLoginButton, GithubLoginButton } from "react-social-login-buttons"
import queryString from "query-string"
import classnames from "classnames"
import { connect } from "react-redux"
import axios from "axios"

import { useContracts, useWallet } from "../libs/useMetaMaskWallet"
import OnSale from "./OnSale"
import Collectibles from "./Collectibles"
import MetamaskLogo from "../assets/images/metamask.png"
import {
    setTwitterLoggedIn,
    setTwitterUserName,
    setNetworkOption,
    setToastMessage,
    setAllTokens,
    setNetwork
} from "../store/common/commonActions"
import { ChainUnsupportedError } from "../libs/useMetaMaskWallet/error"

import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogActions from "@material-ui/core/DialogActions"
import Dialog from "@material-ui/core/Dialog"
import { setSaleTokens, setNFTTokens, setLoading } from "../store/nft/nftActions"
import { convertTokenToNFTDetails } from "../utils"

const Profile = (props) => {
    const {
        nft,
        nft_tokens,
        sale_tokens,
        setAllTokens,
        setSaleTokens,
        setNFTTokens,
        loading,
        setLoading,
        twitterLoggedIn,
        twitterUserName,
        setTwitterLoggedIn,
        setTwitterUserName,
        setNetworkOption,
        setToastMessage,
        setNetwork
    } = props

    const [activeTab, setActiveTab] = useState("1")
    const [nftActiveTab, setNtfActiveTab] = useState("1")
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [openInstallMetaMaskDialog, setOpenInstallMetaMaskDialog] = useState(false)
    const [openAddNftPopup, setOpenAddNftPopup] = useState(false)
    const [newNFTTokenID, setnewNFTTokenID] = useState("")
    const [newNFTTokenType, setnewNFTTokenType] = useState("")
    const [unmatchedErrorMsg, setUnmatchedErrorMsg] = useState("")

    const wallet = useWallet()
    const contracts = useContracts()
    const apiUrlTwitter = "https://twitteroauth.idexo.io"

    const oauthCallbackTwitter = "https://app.idexo.io/profile"

    const newNftTokens = [
        { name: "Avalanche Idexo Community Competition", id: 0 },
        { name: "Idexo Polygon NFT One", id: 1 },
        { name: "Idexo Polygon NFT Two", id: 2 },
        { name: "Idexo BSC Early Adopter", id: 3 }
    ]

    useEffect(() => {
        const fetchNFT = async () => {
            const sale_nft_tokens = []
            const tmp_nft_tokens = []
            setLoading(true)
            for (let i = 0; i < nft.length; i++) {
                const item = convertTokenToNFTDetails(nft[i])
                if (item.source.includes("avalanche") && wallet?.ethereum?.network?.chainId === 43114) {
                    const token_uri = await contracts.avalanche.getTokenURI(item.token_id)
                    const token_details = await axios.get(token_uri)
                    const onSale = await contracts.tradeAvalanche.getOrderState(item.token_id)
                    if (onSale && onSale !== "0") {
                        sale_nft_tokens.push({
                            ...item,
                            details: token_details.data
                        })
                    } else {
                        tmp_nft_tokens.push({
                            ...item,
                            details: token_details.data
                        })
                    }
                } else if (item.source.includes("polygon") && wallet?.ethereum?.network?.chainId === 137) {
                    const token_uri = await contracts.polygon.getTokenURI(item.token_id)
                    const accelerator = await contracts.polygon.getTokenAccelerator(item.token_id)
                    const token_details = await axios.get(token_uri)
                    const onSale = await contracts.tradePolygon.getOrderState(item.token_id)
                    if (onSale && onSale !== "0") {
                        sale_nft_tokens.push({
                            ...item,
                            details: token_details.data,
                            accelerator
                        })
                    } else {
                        tmp_nft_tokens.push({
                            ...item,
                            details: token_details.data,
                            accelerator
                        })
                    }
                }
            }
            setSaleTokens(sale_nft_tokens)
            setNFTTokens(tmp_nft_tokens)
            setAllTokens([ ...sale_nft_tokens, ...tmp_nft_tokens ])
        }

        if (wallet.status === "connected") {
            setIsConnectedToWallet(true)
        } else {
            setIsConnectedToWallet(false)
        }
        if (nft.length) {
            fetchNFT()
        }
    }, [contracts, wallet, nft, setLoading, setNFTTokens, setSaleTokens, setAllTokens])

    const handleConnect = async () => {
        setNetworkOption("")
        setNetwork("Metamask")
        try {
            await wallet.connect()
            if (wallet.error && wallet.error.name === "NoEthereumProviderError") {
                setOpenInstallMetaMaskDialog(true)
            } else {
                setIsConnectedToWallet(true)
            }
        } catch (error) {
            setNetworkOption("Ethereum")
            if (error instanceof ChainUnsupportedError) {
                console.log(error.message)
                setToastMessage("error", error.message)
            } else {
                console.error(error)
                setOpenInstallMetaMaskDialog(true)
            }
        }
    }

    const fetchNFTToken = async () => {
        let owner, message
        switch (newNFTTokenType) {
            case "0":
                if (wallet?.ethereum?.network?.chainId === 43114) {
                    owner = await contracts.avalanche.getOwnerOfToken(newNFTTokenID)
                } else {
                    message = "Please set your Metamask network to Avalanche"
                }
                break
            case "1":
                if (wallet?.ethereum?.network?.chainId === 137) {
                    owner = await contracts.polygon.getOwnerOfToken(newNFTTokenID)
                } else {
                    message = "Please set your Metamask network to Polygon"
                }
                break
            case "2":
                if (wallet?.ethereum?.network?.chainId === 137) {
                    owner = await contracts.polygon.getOwnerOfToken(newNFTTokenID)
                } else {
                    message = "Please set your Metamask network to Polygon"
                }
                break
            default:
                break
        }

        console.log(owner, contracts)
        const match = wallet.account === owner
        if (match) {
            setnewNFTTokenID("")
            setnewNFTTokenType("")
            setOpenAddNftPopup(false)
        } else {
            setUnmatchedErrorMsg(message || "You're not the owner")
        }
    }

    const requestTwitterOAuthToken = async () => {
        // const response = await fetch(apiUrlTwitter, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json",
        //         token: localStorage.jwtToken
        //     },
        //     body: JSON.stringify({
        //         oauthCallback: oauthCallbackTwitter
        //     })
        // }).then(res => { return res })
        // const oauth_token = 'yo'
        // console.log("response is " + JSON.stringify(response))
        // return oauth_token
        return fetch(apiUrlTwitter, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            body: JSON.stringify({
                oauthCallback: oauthCallbackTwitter
            })
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data.data)
                if (data.error) {
                    console.log("Error: " + data.error)
                } else {
                    return data.data.oauth_token
                }
            })
    }

    const goTwitterAuth = async () => {
        const oauthToken = await requestTwitterOAuthToken()
        // window.open(`https://api.twitter.com/oauth/authenticate?oauth_token=${oauthToken}`)
        return oauthToken
        // window.open(`https://api.twitter.com/oauth/authenticate?oauth_token=${oauthToken}`)
    }

    const goToInstallMetaMaskPage = () => {
        window.open("https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn", "_blank")
        setOpenInstallMetaMaskDialog(false)
    }

    useEffect(() => {
        ;(async () => {
            if (!twitterLoggedIn) {
                const { oauth_token, oauth_verifier } = queryString.parse(window.location.search)

                if (oauth_token && oauth_verifier) {
                    try {
                        //Oauth Step 3
                        // await axios({
                        //   url: `${apiPath}/twitter/oauth/access_token`,
                        //   method: 'POST',
                        //   data: {oauth_token, oauth_verifier}
                        // });

                        // TODO: API Endpoints need to be changed
                        // Need to think about saving access token in somewhere else.
                        return fetch(apiUrlTwitter, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                token: localStorage.jwtToken
                            },
                            body: JSON.stringify({
                                oauthCallback: oauthCallbackTwitter,
                                oauth_token: oauth_token,
                                oauth_verifier: oauth_verifier
                            })
                        })
                            .then((res) => res.json())
                            .then((data) => {
                                console.log(data.data.results)
                                if (data.error) {
                                    console.log("Error: " + data.error)
                                } else {
                                    setTwitterLoggedIn(true)
                                    setTwitterUserName(data.data.results.screen_name)
                                }
                            })
                    } catch (error) {
                        console.error(error)
                    }
                }
            }

            // try {
            //     //Authenticated Resource Access
            //     // const {data: {name, profile_image_url_https, status, entities}} = await axios({
            //     //   url: `${apiPath}/twitter/users/profile_banner`,
            //     //   method: 'GET'
            //     // });

            //     // TODO: API Endpoints need to be changed.
            //     const { username, points } = await fetch(apiUrlTwitter, {
            //         method: "POST",
            //         headers: {
            //             "Content-Type": "application/json",
            //             token: localStorage.jwtToken
            //         },
            //         body: JSON.stringify({
            //             oauthCallback: oauthCallbackTwitter,
            //             oauth_token: oauth_token,
            //             oauth_verifier: oauth_verifier
            //         }),
            //         json: true
            //     })

            //     // setIsTwitterLoggedIn(true)
            //     // setTwitterUserName(username)
            //     setPoints(points)
            // } catch (error) {
            //     console.error(error)
            // }
        })()
    }, [])

    return (
        <React.Fragment>
            <div className="content profile-page">
                <Card>
                    <CardHeader className="bg-transparent border-bottom">
                        <ul className="nav nav-tabs nav-tabs-custom card-header-tabs ms-auto" role="tablist">
                            <NavItem>
                                <NavLink
                                    to="#"
                                    className={classnames({
                                        active: activeTab === "1"
                                    })}
                                    onClick={() => {
                                        setActiveTab("1")
                                    }}
                                >
                                    Social
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    to="#"
                                    className={classnames({
                                        active: activeTab === "2"
                                    })}
                                    onClick={() => {
                                        setActiveTab("2")
                                    }}
                                >
                                    NFTs
                                </NavLink>
                            </NavItem>
                        </ul>
                    </CardHeader>
                    <CardBody>
                        <TabContent activeTab={activeTab}>
                            <TabPane className="show" tabId="1">
                                <Row>
                                    <Col md={12} lg={4}>
                                        <FormGroup className="mb-3">
                                            {twitterLoggedIn ? (
                                                <p>
                                                    Welcome @{twitterUserName} - your Twitter username has been
                                                    validated and connected.
                                                </p>
                                            ) : (
                                                <TwitterLoginButton
                                                    onClick={() =>
                                                        goTwitterAuth().then((res) =>
                                                            window.open(
                                                                `https://api.twitter.com/oauth/authenticate?oauth_token=${res}`
                                                            )
                                                        )
                                                    }
                                                />
                                            )}
                                        </FormGroup>
                                        <FormGroup className="mb-3">
                                            <GithubLoginButton onClick={() => alert("Coming Soon")} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex flex-wrap gap-2">
                                    <Button type="submit" color="primary" className="waves-effect waves-light me-3">
                                        Save
                                    </Button>
                                    <Button type="submit" color="secondary" className="waves-effect waves-light">
                                        Cancel
                                    </Button>
                                </div>
                            </TabPane>
                            <TabPane className="show" tabId="2">
                                {!isConnectedToWallet ? (
                                    <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                                        <div className="metamask_logo">
                                            <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                                        </div>
                                        <h1 className="mt-4">Connect Wallet</h1>
                                        <p>
                                            Connecting you Ethereum and the Decentralized Web.
                                            <br />
                                            We're happy to see you.
                                        </p>
                                        <Button
                                            color="primary"
                                            className="waves-effect waves-light"
                                            style={{ width: 200 }}
                                            onClick={() => handleConnect()}
                                        >
                                            Connect
                                        </Button>
                                    </div>
                                ) : (
                                    <div className="ntf-tab-content">
                                        <ul className="nav nav-tabs ms-auto" role="tablist">
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    className={classnames({
                                                        active: nftActiveTab === "1"
                                                    })}
                                                    onClick={() => {
                                                        setNtfActiveTab("1")
                                                    }}
                                                >
                                                    On sale
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    className={classnames({
                                                        active: nftActiveTab === "2"
                                                    })}
                                                    onClick={() => {
                                                        setNtfActiveTab("2")
                                                    }}
                                                >
                                                    Collectibles
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ marginLeft: "auto" }}>
                                                <Button
                                                    color="primary"
                                                    className="waves-effect"
                                                    onClick={() => setOpenAddNftPopup(true)}
                                                >
                                                    Add NFT
                                                </Button>
                                            </NavItem>
                                        </ul>
                                        <TabContent activeTab={nftActiveTab}>
                                            <TabPane className="show" tabId="1">
                                                <OnSale items={sale_tokens} loading={loading} />
                                            </TabPane>
                                            <TabPane className="show" tabId="2">
                                                <Collectibles items={nft_tokens} loading={loading} />
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                )}
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
                <Dialog
                    open={openAddNftPopup}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="sm"
                    fullWidth
                    onClose={() => setOpenAddNftPopup(false)}
                >
                    <DialogTitle id="alert-dialog-title">Add NFT Popup</DialogTitle>
                    <DialogContent>
                        <FormGroup className="mb-3">
                            <Label htmlFor="token-id" className="form-label">
                                Token ID
                            </Label>
                            <Input
                                type="text"
                                id="token-id"
                                placeholder="Token ID"
                                value={newNFTTokenID}
                                onChange={(e) => {
                                    setnewNFTTokenID(e.target.value)
                                    setUnmatchedErrorMsg("")
                                }}
                                style={unmatchedErrorMsg ? { borderColor: "red" } : {}}
                            />
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Label htmlFor="nft-type" className="form-label">
                                NFT Type
                            </Label>
                            <select
                                className="form-select"
                                onChange={(e) => {
                                    setnewNFTTokenType(e.target.value)
                                    setUnmatchedErrorMsg("")
                                }}
                                value={newNFTTokenType}
                                disabled={!newNFTTokenID}
                                style={unmatchedErrorMsg ? { borderColor: "red" } : {}}
                            >
                                <option key="">Choose Type</option>
                                {newNftTokens.map((tokens) => (
                                    <option key={tokens.name} value={tokens.id}>
                                        {tokens.name}
                                    </option>
                                ))}
                            </select>
                        </FormGroup>
                        {unmatchedErrorMsg && <p style={{ color: "red" }}>Error! {unmatchedErrorMsg}</p>}
                        <Button
                            color="primary"
                            autoFocus
                            disabled={!newNFTTokenID || !newNFTTokenType}
                            onClick={fetchNFTToken}
                            style={{ float: "right" }}
                        >
                            Add
                        </Button>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openInstallMetaMaskDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="sm"
                    fullWidth
                    onClose={() => setOpenInstallMetaMaskDialog(false)}
                >
                    <DialogTitle id="alert-dialog-title">Install MetaMask</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Please install MetaMask wallet on your browser to connect
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" autoFocus onClick={goToInstallMetaMaskPage}>
                            {" "}
                            Install MetaMask{" "}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    twitterUserName: state.commonReducer.twitterUserName,
    twitterLoggedIn: state.commonReducer.twitterLoggedIn,
    nft: state.nftReducer.items,
    sale_tokens: state.nftReducer.sale_tokens,
    nft_tokens: state.nftReducer.tokens,
    loading: state.nftReducer.loading
})

const mapDispatchToProps = {
    setNetworkOption,
    setTwitterUserName,
    setTwitterLoggedIn,
    setAllTokens,
    setSaleTokens,
    setNFTTokens,
    setLoading,
    setToastMessage,
    setNetwork
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
